// extracted by mini-css-extract-plugin
module.exports = {"slides":"B7kt","headerWrap":"B7kv","header":"B7ap","headerLink":"B7kx","navBtn":"B7k1","sliderWrapper":"B7k5"};